import React from 'react';
import styles from './ChatListTopPanel.module.scss';
import {Text} from "../../../../modules";
import {useTranslation} from "react-i18next";
import {FilterCheckIcon} from "../../../../image";
import {Tooltip} from "antd";
import {useSelector} from "react-redux";
import classNames from "classnames";
import {FILTERS} from "../../helpers";
import {UpdateChatSessionService} from "../../../../redux/actions/chatActions";
import {useLocation} from "react-router-dom";

const ChatListTopPanel = ({activeTab, setActiveTab}) => {
    const {t} = useTranslation();
    const location = useLocation();
    const sessionsList = useSelector(state => state.chat.sessionsInfo || []);
    const allSessionsCount = sessionsList.length;
    const notReadSessionsCount = sessionsList.filter((session) => !session.is_read).length;
    const sessionsInfo = useSelector(state => state.chat.sessionsInfo);
    const isCheckVideoPage = (location.pathname || '').includes('/dashboard/videos/video');
    const isGlobalChat = useSelector(state => state.chat.isGlobalChat);
    const videoInfo = useSelector(state => state.videos.videoById);

    const allReadSessions = () => {
        try{
            sessionsInfo.filter((session)=>!session.is_read).forEach((session)=>{
                UpdateChatSessionService(session?.id, {is_read: true});
            })
        }catch (e) {
            console.error(e)
        }
    }

    return (
        <div className={styles['session-panel']}>
            <div className={styles['session-panel__filters']}>
                {isCheckVideoPage ?
                    <>
                        {!isGlobalChat ?
                            null
                            :
                                    <Text size="f13" font="book" color="#828282" >{t('global_chat')}</Text>
                        }
                    </>
                    : null}
                {isCheckVideoPage && !isGlobalChat ?
                    <>
                        <Text size="f13" font="book" color="#828282" >
                            {t('local_chats_for_video')}
                            <Text size="f13" font="bold" color="#828282">{' '}{videoInfo?.description}</Text>
                        </Text>

                    </>
                :
                    <>
                <div
                    className={
                        classNames(
                            styles['session-panel__filters--item'],
                            {
                                [styles['session-panel__filters--item--active']]: activeTab === FILTERS.ALL
                            }
                        )
                    }
                    onClick={()=>setActiveTab(FILTERS.ALL)}
                >
                    <Text
                        size="f13"
                        className={styles['session-panel__filters--item--text']}
                        color={activeTab === FILTERS.ALL ? 'black' : '#A8A8AC'}
                    >
                        {t('all_users_title')}{' '}
                    </Text>
                    {allSessionsCount ? <Text size="f13" className={styles['session-panel__filters--item--text']}
                          color="#A8A8AC">({allSessionsCount})</Text> : null}
                </div>
                <div
                    className={
                        classNames(
                            styles['session-panel__filters--item'],
                            {
                                [styles['session-panel__filters--item--active']]: activeTab === FILTERS.NOT_READ
                            }
                        )
                    }
                    onClick={()=>setActiveTab(FILTERS.NOT_READ)}
                >
                    <Text
                        size="f13"
                        className={styles['session-panel__filters--item--text']}
                        color={activeTab === FILTERS.NOT_READ ? 'black' : '#A8A8AC'}
                    >
                        {t('not_read')}{' '}
                    </Text>
                    {notReadSessionsCount ? <Text size="f13" className={styles['session-panel__filters--item--text']}
                                                  color="#A8A8AC">({notReadSessionsCount})</Text> : null}
                </div>
                <Tooltip
                    placement="left"
                    title={t('mark_every_as_read')}
                >
                    <FilterCheckIcon
                        className={styles['session-panel__filters--icon']}
                        onClick={allReadSessions}
                    />
                </Tooltip>
                    </>
                }
            </div>
        </div>
    );
};

export default ChatListTopPanel;